import { RequestTypes } from 'legacy/lut/classes/models/onboarding/Onboarding'

export const ALLOWED_REQUEST_TYPES = [RequestTypes.Onboarding, RequestTypes.RetailOnboarding]
